// OLM_OPTIONS is undefined https://gitlab.matrix.org/matrix-org/olm/-/issues/10
import { DecryptionError } from './base';
// but this comment suggests we define it ourselves? https://gitlab.matrix.org/matrix-org/olm/-/blob/master/javascript/olm_pre.js#L22-24
globalThis.OLM_OPTIONS = {};
/**
 * Utilities common to Olm encryption
 */
// Supported algorithms
export var EncryptionAlgorithmId;
(function (EncryptionAlgorithmId) {
    EncryptionAlgorithmId["Olm"] = "r.olm.v1.curve25519-aes-sha2";
})(EncryptionAlgorithmId || (EncryptionAlgorithmId = {}));
export var GroupEncryptionAlgorithmId;
(function (GroupEncryptionAlgorithmId) {
    // group olm encryption based on signal protocol with ratcheting
    GroupEncryptionAlgorithmId["GroupEncryption"] = "r.group-encryption.v1.aes-sha2";
    // asymmetric encryption (olm) to share symmetric encryption (AES-GSM-256) keys
    GroupEncryptionAlgorithmId["HybridGroupEncryption"] = "grpaes";
})(GroupEncryptionAlgorithmId || (GroupEncryptionAlgorithmId = {}));
export function isGroupEncryptionAlgorithmId(value) {
    return Object.values(GroupEncryptionAlgorithmId).includes(value);
}
export function parseGroupEncryptionAlgorithmId(value, defaultValue) {
    if (!value || value === '') {
        if (defaultValue) {
            return { kind: 'matched', value: defaultValue };
        }
        else {
            throw new DecryptionError('GROUP_DECRYPTION_UNSET_ALGORITHM', 'algorithm is unset');
        }
    }
    if (isGroupEncryptionAlgorithmId(value)) {
        return { kind: 'matched', value };
    }
    return { kind: 'unrecognized', value };
}
//# sourceMappingURL=olmLib.js.map